import { FC, PropsWithChildren, useMemo } from 'react';
import createSafeContext from '@paradigm/utils/createSafeContext';
import GrfqBboService, { createGrfqBboService } from '../services/grfq-bbo';

const [useGrfqBboService, GrfqBboServiceProvider] =
  createSafeContext<GrfqBboService>('GrfqBboService');

const GrfqBboServiceContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const grfqBboService = useMemo(() => createGrfqBboService(), []);

  return (
    <GrfqBboServiceProvider value={grfqBboService}>
      {children}
    </GrfqBboServiceProvider>
  );
};

export { useGrfqBboService, GrfqBboServiceContextProvider };
